/**
 * @generated SignedSource<<830b4f4d993a897f600210984ac29e18>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailReturnPolicy_sku">;
  readonly " $fragmentType": "PdpRespShippingReturns_sku";
};
export type PdpRespShippingReturns_sku$key = {
  readonly " $data"?: PdpRespShippingReturns_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespShippingReturns_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_sku",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReturnPolicy_sku"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "9d285b534644e4768d28ec30447ebc99";

export default node;
